"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APImage = void 0;
var react_1 = __importDefault(require("react"));
function APImage(_a) {
    var src = _a.src, height = _a.height, width = _a.width, alt = _a.alt, style = _a.style, fit = _a.fit;
    if (fit)
        return (react_1.default.createElement("div", { style: { backgroundImage: "url(" + src + ")", backgroundColor: "#eee", backgroundSize: "contain", backgroundRepeat: "no-repeat", backgroundPosition: "center", height: height, width: width } }));
    return react_1.default.createElement("img", { src: src, height: height, width: width, alt: alt, style: style });
}
exports.APImage = APImage;
